/**
 * Career Catalyst brand gradient — the wordmark's indigo → blue → cyan family.
 * One gradient element per view: the primary CTA, or the slogan's second line.
 * Stops are theme tokens (--brand-from/-via/-to in src/index.css).
 */
export const BRAND_GRADIENT = 'bg-gradient-to-r from-brand-from via-brand-via to-brand-to';

/** Gradient text treatment for the slogan line. */
export const BRAND_GRADIENT_TEXT = `${BRAND_GRADIENT} bg-clip-text text-transparent`;
